import { Component, Input, OnInit, Type } from "@angular/core";
import { BadgeTextColData } from "../../models/columns/badge-text-col";
import { Col } from "../../models/columns/col";
import { ICellComponent } from "../../models/i-cell-component";

@Component({
  selector: "app-badge-text",
  templateUrl: "./badge-text.component.html",
  styleUrls: ["./badge-text.component.scss"],
})
export class BadgeTextComponent<T extends object>
  implements OnInit, ICellComponent<T>
{
  @Input() badgeContent!: string;
  @Input() text!: string;
  badgeClass!: string;
  @Input() image!: string;

  data!: BadgeTextColData;

  constructor() {}

  ngOnInit(): void {}

  setComponentData(element: T, colConfig: Col<T, Type<BadgeTextComponent<T>>>) {
    this.data = colConfig.getElementData(element);

    this.badgeClass = this.data.badgeClass;
    this.badgeContent = this.data.badgeContent;
    this.image = this.data.image;
    this.text = this.data.text;
  }
}
